/** Autogenerated by public2business schematic. DO NOT CHANGE! */
/* tslint:disable */
import { InjectionToken } from '@angular/core';

export const SBB_DATEPICKER = new InjectionToken<any>('SBB_DATEPICKER');
